import { render } from "./DeviceScreenshot.vue?vue&type=template&id=724a613a"
import script from "./DeviceScreenshot.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceScreenshot.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/DeviceScreenshot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "724a613a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('724a613a', __exports__)) {
    api.reload('724a613a', __exports__)
  }
  
  module.hot.accept("./DeviceScreenshot.vue?vue&type=template&id=724a613a", () => {
    api.rerender('724a613a', render)
  })

}


export default __exports__